<template>
	<div class='knd-intro knd-wrapper' >
		<div class="knd-wrapper-inner">
		<div ref="scrollRef" class="audio-switch">
			<div class="audio--message">
				Dit verhaal ervaar je beter met geluid
				<AudioToggle />
			</div>

			<div class="scroll-down">
				<div>scroll verder</div>
				<svg class="icon-scroll-down animate-bounce" viewBox="0 0 8 23" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M4.5 1C4.5 0.723858 4.27614 0.5 4 0.5C3.72386 0.5 3.5 0.723858 3.5 1L4.5 1ZM3.64645 22.3536C3.84171 22.5488 4.15829 22.5488 4.35355 22.3536L7.53553 19.1716C7.7308 18.9763 7.7308 18.6597 7.53553 18.4645C7.34027 18.2692 7.02369 18.2692 6.82843 18.4645L4 21.2929L1.17157 18.4645C0.976311 18.2692 0.659729 18.2692 0.464467 18.4645C0.269205 18.6597 0.269205 18.9763 0.464467 19.1716L3.64645 22.3536ZM3.5 1L3.5 22L4.5 22L4.5 1L3.5 1Z" fill="url(#paint0_linear_13_52)"/>
					<defs>
					<linearGradient id="paint0_linear_13_52" x1="4.5" y1="1" x2="4.5" y2="22" gradientUnits="userSpaceOnUse">
					<stop stop-color="#575757"/>
					<stop offset="0.5" stop-color="white"/>
					<stop offset="1" stop-color="#6A706D"/>
					</linearGradient>
					</defs>
				</svg>
			</div>

		</div> 
		</div>
	</div>
</template>

<script>

import { useStore } from 'vuex'
import { ref, onMounted } from 'vue';

import AudioToggle from '@/components/audio';

export default {
	components: {AudioToggle},
  setup () {
    const store = useStore()

    const locationAssets = ref(process.env.VUE_APP_ASSETS);

    return {
      data: store.getters.data,
      locationAssets
    }
  }
}
</script>


<style lang="scss">
.knd-intro {
  min-height: 50vh;
}



.audio--message {
	background: #4C00FF;
	border-radius: 26px;
	color: #FFF;
	padding: 1em 2em;
	font-size: 1.4rem;

	.knd-toggle-container {
		margin-top: 1em;
		.knd-toggle{
			justify-content: center;
		}
	}

	.knd-icon-mute {
		margin: 0 auto;
	}
}

.icon-scroll-down {
	height: 30px;
	margin-top: 20px;
}

.audio-switch {
    //position: absolute;
   // top: 150px;
   // left: 50%;
    //transform: translateX(-50%);
    // opacity: 0;
		max-width: 450px;
		margin: 0 auto;
		position: relative;
		text-align: center;
    transition: opacity .4s ease-in;

    &.triggered {
      opacity: 1;
    }
  }

	.scroll-down {
		margin-top: 3em;
		// background: #2b0875;
		text-align: center;
		div {
			font-size: 1.2rem;
			margin: 0 auto;
			display: block;
		}

	}
</style>